import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.syncedExportGeneralLedgerDialog,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.syncedExportGeneralLedgerDialog) = $event)),
        title: _ctx.title,
        onPrevious: _ctx.previous,
        "previous-display": !!_ctx.exportWindowStep,
        onClose: _cache[14] || (_cache[14] = ($event: any) => (_ctx.resetExportDialog())),
        "valid-title": _ctx.exportWindowStep === 2 ? 'Valider' : 'Suivant',
        "hide-valid": _ctx.exportWindowStep !== 0 && _ctx.exportWindowStep !== 1,
        "valid-disabled": 
                !_ctx.dateValid ||
                !_ctx.GLOrBalance ||
                !_ctx.GLOrBalance.length ||
                (_ctx.fromExportAccounting && !_ctx.exportThirdParty.length)
            ,
        onValid: _cache[15] || (_cache[15] = ($event: any) => (_ctx.nextStepExportDialog())),
        prefixDataCy: "GeneralLedgerExportDialog-valid",
        minWidth: "40vw",
        maxWidth: "50vw"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window, {
            modelValue: _ctx.exportWindowStep,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.exportWindowStep) = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_component_v_window_item, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_form, {
                    modelValue: _ctx.dateValid,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dateValid) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_oss_date_picker_filled, {
                        modelValue: _ctx.dateRange.start,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateRange.start) = $event)),
                        filterWithoutClosedAccountingPeriods: false,
                        mandatory: true,
                        label: "Date de début d'export",
                        textFieldReadOnly: false,
                        minDate: _ctx.mAccountingPeriodStart || _ctx.mMaxStartDate || undefined,
                        maxDate: _ctx.mAccountingPeriodEnd || undefined,
                        class: "mt-2",
                        "data-cy": "GeneralLedger2-startExportDate"
                      }, null, 8, ["modelValue", "minDate", "maxDate"]),
                      _createVNode(_component_oss_date_picker_filled, {
                        modelValue: _ctx.dateRange.end,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dateRange.end) = $event)),
                        filterWithoutClosedAccountingPeriods: false,
                        label: "Date de fin d'export",
                        mandatory: true,
                        textFieldReadOnly: false,
                        minDate: _ctx.mAccountingPeriodStart || _ctx.mMaxStartDate || undefined,
                        maxDate: _ctx.mAccountingPeriodEnd || undefined,
                        "data-cy": "GeneralLedger2-endExportDate"
                      }, null, 8, ["modelValue", "minDate", "maxDate"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })),
              (_openBlock(), _createBlock(_component_v_window_item, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    "no-gutters": "",
                    "data-cy": "GeneralLedger2-reconciliation"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        "data-cy": "GeneralLedger2-reconciliation"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_radio_group, {
                            modelValue: _ctx.reconciliation,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.reconciliation) = $event)),
                            mandatory: "",
                            inline: "",
                            "data-cy": "GeneralLedger2-reconciliation",
                            color: "primary"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_radio, {
                                label: "Toutes les écritures",
                                value: "all",
                                "data-cy": "GeneralLedgerExportDialog-all"
                              }),
                              _createVNode(_component_v_radio, {
                                label: "Uniquement les non lettrées",
                                value: "onlyNotReconciliated",
                                "data-cy": "GeneralLedgerExportDialog-onlyNotReconciliated"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "6",
                        "data-cy": "GeneralLedgerExportDialog-grand-livre"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_checkbox, {
                            modelValue: _ctx.GLOrBalance,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.GLOrBalance) = $event)),
                            label: "Inclure le Grand Livre",
                            value: "generalLedger"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "6",
                        "data-cy": "GeneralLedgerExportDialog-balance"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_checkbox, {
                            modelValue: _ctx.GLOrBalance,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.GLOrBalance) = $event)),
                            label: "Inclure la Balance",
                            value: "balance"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.fromExportAccounting === true)
                    ? (_openBlock(), _createBlock(_component_v_divider, { key: 0 }))
                    : _createCommentVNode("", true),
                  (_ctx.fromExportAccounting === true)
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 1,
                        "no-gutters": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "6" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_checkbox, {
                                modelValue: _ctx.exportThirdParty,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.exportThirdParty) = $event)),
                                label: "Comptes généraux",
                                value: 'general'
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "6" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_checkbox, {
                                modelValue: _ctx.exportThirdParty,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.exportThirdParty) = $event)),
                                label: "Comptes tiers",
                                value: 'thirdParty'
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })),
              (_openBlock(), _createBlock(_component_v_window_item, { key: 2 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_checkbox, {
                        modelValue: _ctx.exportWithProjectWatermark,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.exportWithProjectWatermark) = $event)),
                        ripple: false,
                        class: "ml-1 mb-2",
                        title: _ctx.$t('shared.exportWithProjectWatermark'),
                        label: _ctx.$t('shared.exportWithProjectWatermark')
                      }, null, 8, ["modelValue", "title", "label"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_list, {
                    subheader: "",
                    lines: "two"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, {
                        class: _normalizeClass(
                                !_ctx.$vuetify.display.mobile
                                    ? 'mb-2 oss-list-item'
                                    : 'mb-2 px-2 oss-list-item'
                            ),
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.exportFile('XLSX'))),
                        disabled: _ctx.exportWithProjectWatermark,
                        "data-cy": "GeneralLedgerExportDialog-excel"
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, { color: "secondary" }, {
                            default: _withCtx(() => _cache[16] || (_cache[16] = [
                              _createTextVNode(" $fa-file-excel ")
                            ])),
                            _: 1
                          })
                        ]),
                        append: _withCtx(() => [
                          _createVNode(_component_v_btn_next)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => _cache[17] || (_cache[17] = [
                              _createTextVNode("Excel")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class", "disabled"]),
                      _createVNode(_component_v_list_item, {
                        class: _normalizeClass(
                                !_ctx.$vuetify.display.mobile
                                    ? 'mb-2 oss-list-item rounded-lg'
                                    : 'mb-2 px-2 oss-list-item rounded-lg'
                            ),
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.exportFile('DOCX'))),
                        "data-cy": "GeneralLedgerExportDialog-docs"
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, { color: "secondary" }, {
                            default: _withCtx(() => _cache[18] || (_cache[18] = [
                              _createTextVNode(" $fa-file-word ")
                            ])),
                            _: 1
                          })
                        ]),
                        append: _withCtx(() => [
                          _createVNode(_component_v_btn_next)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => _cache[19] || (_cache[19] = [
                              _createTextVNode("Docx")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]),
                      _createVNode(_component_v_list_item, {
                        class: _normalizeClass(
                                !_ctx.$vuetify.display.mobile
                                    ? 'mb-2 oss-list-item rounded-lg'
                                    : 'mb-2 px-2 oss-list-item rounded-lg'
                            ),
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.exportFile('PDF'))),
                        "data-cy": "GeneralLedgerExportDialog-PDF"
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, { color: "secondary" }, {
                            default: _withCtx(() => _cache[20] || (_cache[20] = [
                              _createTextVNode(" $fa-file-pdf ")
                            ])),
                            _: 1
                          })
                        ]),
                        append: _withCtx(() => [
                          _createVNode(_component_v_btn_next)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => _cache[21] || (_cache[21] = [
                              _createTextVNode("PDF")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["modelValue", "title", "onPrevious", "previous-display", "valid-title", "hide-valid", "valid-disabled"])
    ]),
    _: 1
  }))
}